import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';

import { Button } from '@flipster/ui';

import { TpslSchema } from '@web/features/modals/TimeTriggerTpslModal/bunja/validation';

import styles from '../../tpslModal.module.scss';

interface Props {
  isLoading: boolean;
}

const ConfirmButton = ({ isLoading }: Props) => {
  const transCommon = useTranslations('Common.r250401');
  const {
    formState: { isDirty, errors },
  } = useFormContext<TpslSchema>();

  return (
    <footer className={styles.confirmWrapper}>
      <Button
        shape='primary'
        size='large'
        className={styles.confirm}
        isSubmit
        loading={isLoading}
        disabled={!isDirty || !!errors.triggerPrice}
      >
        {transCommon('Confirm')}
      </Button>
    </footer>
  );
};

export default ConfirmButton;
